(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ibg-mobile-menu"] && !Shopify.designMode) return;
  try {
    customElements.whenDefined('mobile-navigation').then(() => {
    if (customElements.get('ibg-mobile-navigation')) return;
    const NativeNavigation = customElements.get('mobile-navigation');
    customElements.define('ibg-mobile-navigation', class extends NativeNavigation {
      get apparitionAnimation() { return null; }
      get shouldTrapFocus() { return false; }

      connectedCallback() {
        super.connectedCallback();
        this.mobileQuery = window.matchMedia('(max-width: 740px)');
        this.onViewportChange = () => { if (!this.mobileQuery.matches) this.open = false; };
        this.mobileQuery.addEventListener('change', this.onViewportChange);
        this.onViewportChange();
        if (!this.open) {
          document.querySelectorAll(`[aria-controls="${this.id}"][aria-expanded="true"]`).forEach(control => control.setAttribute('aria-expanded', 'false'));
        }
        this.delegate.on('click', '[data-ibg-search]', event => {
          const search = document.getElementById('search-drawer');
          if (!search) return;
          event.preventDefault();
          this._focusTrap?.deactivate({ returnFocus: false });
          this.open = false;
          document.querySelector('store-header [aria-controls="search-drawer"]')?.focus({ preventScroll: true });
          search.open = true;
        });
        this.delegate.on('click', '.ibg-header__link[href]', () => { this.open = false; });
      }

      disconnectedCallback() {
        clearTimeout(this.focusTimer);
        this.mobileQuery?.removeEventListener('change', this.onViewportChange);
        this._focusTrap?.deactivate({ returnFocus: false });
        this.open = false;
        super.disconnectedCallback();
      }

      attributeChangedCallback(name, oldValue, newValue) {
        super.attributeChangedCallback(name, oldValue, newValue);
        if (name !== 'open') return;
        clearTimeout(this.focusTimer);
        if (this.open) {
          if (!window.matchMedia('(max-width: 740px)').matches) {
            this.open = false;
            return;
          }
          this.focusTimer = setTimeout(() => {
            if (this.open && this.isConnected) this.focusTrap.activate();
          }, 160);
        } else {
          this._focusTrap?.deactivate();
          if (document.querySelector('.drawer[open]')) document.documentElement.classList.add('lock-all');
        }
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
